import React from 'react';
import { useTranslation } from 'react-i18next';
import './SummaryOverview.scss';


export const SummaryOverview: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="summary-overview">
      <h1 className="summary-overview__title">{t('menu.summaryOverviewTitle')}</h1>
    </div>
  );
}
